import { t } from "i18next";
import { BoxShadowLayout, ContentLayout } from "layouts";
import { Transfers } from "modules/transfers";

const TransfersPage = () => {
  return (
    <ContentLayout title={t("Transfers")}>
      <BoxShadowLayout>
        <Transfers />
      </BoxShadowLayout>
    </ContentLayout>
  );
};

export default TransfersPage;
